// Points every account link at the Recharge portal once a session is known.
// Server-side, snippets/account-url.liquid already renders the right URL
// (data-url). This covers what Liquid can't: FAQ / Terms copy links written
// as /tools/recurring/login, and the first portal page after login, where
// the header was rendered before snippets/portal-session-sync.liquid stored
// the session (it sets window.goodprepPortalSession / fires
// `goodprep:portal-session`).
//
// Hooks: [data-account-link] gets the URL; [data-account-link="in"] is
// shown and [data-account-link="out"] hidden when logged in.
if (!customElements.get("goodprep-account-links")) {
  customElements.define(
    "goodprep-account-links",
    class GoodprepAccountLinks extends HTMLElement {
      static LOGIN_PATH = "/tools/recurring/login";
      static PORTAL_PATH = "/tools/recurring/portal/";

      connectedCallback() {
        this.onSession = (event) => this.apply(event.detail?.url);
        document.addEventListener("goodprep:portal-session", this.onSession);
        const known = window.goodprepPortalSession?.url || this.dataset.url || "";
        if (known.startsWith(GoodprepAccountLinks.PORTAL_PATH)) this.apply(known);
      }

      disconnectedCallback() {
        document.removeEventListener("goodprep:portal-session", this.onSession);
      }

      apply(url) {
        if (!url || !url.startsWith(GoodprepAccountLinks.PORTAL_PATH)) return;
        document.querySelectorAll("[data-account-link]").forEach((link) => {
          link.setAttribute("href", url);
          const state = link.dataset.accountLink;
          if (state === "in") link.hidden = false;
          if (state === "out") link.hidden = true;
        });
        const main = document.getElementById("MainContent") || document.body;
        main.querySelectorAll(`a[href="${GoodprepAccountLinks.LOGIN_PATH}"]`).forEach((link) => {
          link.setAttribute("href", url);
        });
      }
    },
  );
}
